var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-rows',[_c('back-office-form',{attrs:{"inputs":_vm.inputs,"mode":"create","modes":_vm.modes},on:{"submit":_vm.createCasinoIntegrationOption}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }